import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'

import auth from './auth'
import layout from './layout'
import snackbar from './snackbar'
import person from './person'
import company from './company'
import documents from './documents'
import institutions from './institutions'
import vehicles from './vehicles'
import users from './user'
import address from './address'
import contacts from './contacts'
import relationships from './relationships'

import rootSaga from './root.sagas'

const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
    reducer: {
        auth,
        layout,
        snackbar,
        person,
        company,
        documents,
        institutions,
        vehicles,
        users,
        address,
        contacts,
        relationships
    },
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [sagaMiddleware]
})

sagaMiddleware.run(rootSaga)

export default store
